<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <div class="rightSidePanel active" style="z-index: 99999;">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
        <h2>{{ (isAdvancesDisplay ? 'select_advance' : 'select_category') | translate }}</h2>
      </div>
      <div class="panel-left-btn">
          <button type="button" (click)="fnClosePanel(true);"
              class="btn eod-btn-outline-warning height-38px">
              {{ 'label_close' | translate }}
          </button>
      </div>
    </header>
    
    <div class="block mt-2">
      <div class="input-group">
        <input type="text" class="form-control searchField" #searchField [ngClass]="{ 'has-value': searchField.value }"
          name="searchText" [(ngModel)]="searchText" autocomplete="off">
        <label for="ExpenseCategory">{{ "label_search_criterion" | translate: param }}</label>
        <span class="icons"><a>
            <i class="fas fa-search" aria-hidden="true"></i>
          </a>
        </span>
      </div>
    </div>

    <div class="clear"></div>
    <div class="row">
      <div class="col-lg-12 no-padding-right-left margin-top-15">
        <div class="block fw-700" *ngIf="isAdvancesDisplay">
          {{ "select_advance_text" | translate: param }}
        </div>
        <div class="block overflow-auto heightCalc-10 scrollbar-visible">
          <div class="row">
            <ul class="bulkList" *ngIf="!isAdvancesDisplay">
              <li class=" f-14 d-flex justify-content-between flex-row" style="display: flex !important;" *ngFor="let item of recentCategoryList | grdFilter: { expenseCategoryName: searchText}"
                [ngClass]="{'active': item.orgExpenseCategoryId == selectedOrgExpenseCategoryId,'opacity-60': !item.isActive || (this.isAssignCategoriesToGradePurchased && !item.isAssignedToGrade)}"
                (click)="fnSelectExpenseCategory(item)">
                <span class="text-ellipsis">
                  <app-category-icons [expenseCategoryId]="item.expenseCategoryId"
                    className='svg-fill-theme-new padding-right-10'>
                  </app-category-icons>
                  {{item.expenseCategoryName}}                  
                </span>  
                 
                
                <div>
                  <span class="color-red mr-1" *ngIf="inputData?.nrfcStatus == 1 
                  && (item.baseCategoryId == 1 || item.baseCategoryId == 2 || item.baseCategoryId == 3)">
                  ({{ 'vehicle_mangt_msg10' | translate }})
                </span>      
                <i *ngIf="item.isRecentCategory" class="far fa-clock "></i>
                </div>
                
              </li>
            </ul>

            <ul class="bulkList" *ngIf="isAdvancesDisplay">
              <li class="border-bottom padding-bottom-12  f-14 " *ngFor="let item of advancesList"
                (click)="fnSelectAdvanceItem(item)" [ngClass]="{'active': item.advanceId == selectedAdvanceId }">
                <span class="fw-700">{{ 'cash_advance_on_credit_card_title' | translate }}</span>
                <span class="d-inline-block w-100p">{{item.amount}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-alert-panel *ngIf="showPopUpForNoCategorySetup" [data]="showPopUpForNoCategorySetupModel"
    (callbackEvent)="fnShowPopUpForNoCategorySetupReceiver($event)">
</app-alert-panel>


<div id="rightSideBar" *ngIf="showTemplateInfoPanel">
  <div class="overLayDiv active"></div>
    <div class="rightSidePanel d-flex flex-column active" style="z-index: 99999;">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ 'info' | translate }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnCloseTemplateInfoPanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="eod-panel-body">
            <div class="block mt-2">
                <h6 class="info-text">
                    <i class="fas fa-info-circle"></i>
                    <span>{{'cat_temp_info_note_1' | translate}} {{totalCategoryAssigned}} {{'cat_temp_info_note_2' | translate}} {{displayCatggoryCount}} {{'cat_temp_info_note_3' | translate}} </span>
                </h6>
                <h6 class="info-text">
                    <i class="fas fa-info-circle"></i>
                    <span>{{'cat_temp_info_note_4'| translate}} {{totalCategoryAssigned - displayCatggoryCount}} {{'cat_temp_info_note_5' | translate}}</span>
                </h6>
                <h6 class="info-text">
                    <i class="fas fa-info-circle"></i>
                    <span>{{'cat_temp_info_note_6' | translate}}</span>
                </h6>

                <h6 class="info-text">
                    <i class="fas fa-info-circle"></i>
                    <span>{{'cat_temp_info_note_7'| translate}}</span>
                </h6>
            </div>
        </div>
    </div>
</div>

